import React from 'react';
import { Box, Button, Text } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';
import { THEME_COLORS } from '../../theme/ThemeConstants';
import { formatPrice } from '../../utilities/Currency';

interface CheckoutButtonProps {
  isEmpty: boolean;
  isLoading: boolean;
  total: number;
  currency: string;
  itemCount: number;
  onClick: () => void;
  fullWidth?: boolean;
}

export const CheckoutButton: React.FC<CheckoutButtonProps> = ({
  isEmpty,
  isLoading,
  total,
  currency,
  itemCount,
  onClick,
  fullWidth = false
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      size='md'
      onClick={onClick}
      disabled={isEmpty || isLoading}
      leftSection={isEmpty ? <IconShoppingCart size={16} /> : undefined}
      styles={{
        root: {
          backgroundColor: isEmpty ? '#5a6c4a' : THEME_COLORS.accent.primary,
          height: 48,
          fontSize: 14,
          fontWeight: 600,
          '&:disabled': {
            backgroundColor: '#5a6c4a',
            color: '#9aa890'
          }
        }
      }}
    >
      {isEmpty ? (
        'CHECKOUT'
      ) : (
        <Box>
          <Text size='sm' fw={600} style={{ lineHeight: 1.2 }}>
            CHECKOUT
          </Text>
          <Text size='xs' fw={400} style={{ lineHeight: 1.2 }}>
            {formatPrice(total, currency)} ({itemCount}{fullWidth ? ` item${itemCount > 1 ? 's' : ''}` : ''})
          </Text>
        </Box>
      )}
    </Button>
  );
};

